module.exports = __webpack_public_path__ + "static/media/FBwithround.9b74c9bc.svg";